export const sample = {
    "calendar": {
        "calendar01": "行事曆-修改",
        "calendar02": "今天",
        "calendar03": "行事曆-新增",
        "calendar04": "行事曆-檢視",
        "calendar05": "標題",
        "calendar06": "起始時間",
        "calendar07": "結束時間",
        "calendar08": "狀態",
        "calendar09": "公告部門",
        "calendar10": "內容",
        "calendar11": "新增行事曆",
        "calendar12": "tYY年MM月"
    },
    "barcode": {
        "barcode01": "注意事項",
        "barcode02": "輸入框須為英文輸入法，因為條碼通常是數字組成",
        "barcode03": "掃描器會模擬鍵盤輸入，在掃完條碼讀取數字後，輸入完自動執行enter",
        "barcode04": "條碼機測試",
        "barcode05": "如果手邊沒有條碼機，可以下載",
        "barcode06": "安裝設定完畢後，用手機也可以掃描條碼測試",
        "barcode07": "條碼輸入",
        "barcode08": "顯示條碼",
        "barcode09": "測試"
    },
    "chart": {
        "chart01": "星期一",
        "chart02": "星期二",
        "chart03": "星期三",
        "chart04": "星期四",
        "chart05": "星期五",
        "chart06": "星期六",
        "chart07": "星期日",
        "chart08": "可參考實作範例的資源使用狀況",
        "chart09": "圖表範例",
    },
    "crypt": {
        "crypt01": "加解密失敗,請確認金鑰是否正確",
        "crypt02": "輸入字串",
        "crypt03": "金鑰",
        "crypt04": "預設",
        "crypt05": "輸出字串",
        "crypt06": "加密",
        "crypt07": "解密"
    },
    "tour": {
        "tour01": "歡迎使用Reactour引導工具",
        "tour02": "設定聚焦區塊",
        "tour03": "設定按鈕文字",
        "tour04": "顯示或隱藏按鈕",
        "tour05": "輸入\"GSS\", 按下Enter結束引導工具",
        "tour06": "上一步",
        "tour07": "下一步"
    },
    "css": {
        "css01": "標題",
        "css02": "清單",
        "css03": "按鈕",
        "css04": "無序清單",
        "css05": "有序清單",
        "css06": "橫式清單項目",
        "css07": "項目",
        "css08": "橫式排列"
    },
    "eform": {
        "eform01": "表單欄位定義",
        "eform02": "欄位類型",
        "eform03": "欄位子類型",
        "eform04": "欄位顯示參數",
        "eform05": "長度限制"
    },
    "excel": {
        "excel01": "範例套版檔案",
        "excel02": "範本",
        "excel03": "使用方式",
        "excel04": "產製Excel套表匯出",
        "excel05": "詳細設定參考AsposeExcelSetController的程式下載範例",
        "excel06": "範本樣式",
        "excel07": "縱向動態長資料範例(自動CreateRow)",
        "excel08": "縱向動態長資料範例(預設Row範圍)",
        "excel09": "單一欄位替換",
        "excel10": "以上樣式皆可以參考Excel範例套版檔案",
        "excel11": "支援格式",
        "excel12": "支援 Excel 範本轉 Xlsx、Xls、Ods、Pdf、Html 匯出",
        "excel13": "匯出格式",
    },
    "word": {
        "word01": "使用說明下載",
        "word02": "匯出Word套版",
        "word03": "使用方式",
        "word04": "產製Word套表匯出",
        "word05": "詳細參數設定可參考AsposeWordSet使用說明下載，和參考ExportReportController的程式下載範例",
        "word06": "支援格式",
        "word07": "支援 Word 範本轉 Doc、Docx、Odt、Pdf 匯出",
        "word08": "匯出格式",
        "word09": "匯出範例資料",
        "word10": "參數類別代碼",
        "word11": "參數類別",
        "word12": "說明"
    },
    "resourceUsage": {
        "resourceUsage01": "資源使用狀況"
    },
    "grid": {
        "grid01": "範例",
        "grid02": "代碼",
        "grid03": "功能名稱"
    }
}